import { WSFilter } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayerEngagementFilterOptions } from "../../../../Payers/hooks/usePayerEngagementFilterOptions";

export function useBuildConfig() {
  // v3 `SearchPayerRowsFilterParameter` takes the nested engagement filters as
  // flat `engagements_*` keys with an operator object, replacing the v1 dotted
  // `"engagements.isWorkLoggingEnabled"` string key.
  const assignmentOptions = usePayerEngagementFilterOptions({
    engagements_isWorkLoggingEnabled: { eq: true }
  });

  return useMemo(
    (): WSFilter[] => [
      {
        title: "Assignment",
        name: "assignmentId",
        type: "select",
        apiOptions: assignmentOptions
      }
    ],
    [assignmentOptions]
  );
}
